exports.SidebarWidth = 80
exports.HeaderHeight = 60